import { getShouldShowLuxPlusBeforeCharterFeederFlights } from 'checkout/selectors/navigationSelectors'
import { isLuxPlusSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscriptionItems'
import {
  getCanViewLuxPlusBenefits,
  getIsEnabledFlightsBundleLuxPlusPriceWithSubscriptionInCart,
  getIsEnabledFlightsLuxPlusPreview,
  getIsEnabledFlightsShowLuxPlusPriceToEveryone,
  getIsFlightsLuxPlusPricingEligibleSpoofedNonMember,
  getIsFreePreviewLuxPlusMember,
} from 'luxPlus/selectors/featureToggle'

interface FlightLuxPlusPricingOptions {
  enabled?: boolean
  isBundledFlow?: boolean
}

// Declined Lux Plus Upsell should only apply if the upsell was shown in a charter feeder flow
export function shouldApplyDeclinedLuxPlusUpsell(
  state: App.State,
  isBundledFlow?: boolean,
): boolean {
  return !!isBundledFlow &&
    state.checkout.cart.luxPlusUpsellDecision === 'declined' &&
    getShouldShowLuxPlusBeforeCharterFeederFlights(state)
}

export function canRequestFlightLuxPlusPricing(state: App.State, options: FlightLuxPlusPricingOptions): boolean {
  const { enabled, isBundledFlow } = options
  if (!enabled) {
    return false
  }

  if (shouldApplyDeclinedLuxPlusUpsell(state, isBundledFlow)) {
    return false
  }

  const subscriptionInCart =
    getIsEnabledFlightsBundleLuxPlusPriceWithSubscriptionInCart(state) &&
    isLuxPlusSubscriptionInCart(state)
  const isLuxPlusPricingShownToEveryone = getIsEnabledFlightsShowLuxPlusPriceToEveryone(state)

  const isPreviewMemberBlocked =
    !getIsEnabledFlightsLuxPlusPreview(state) &&
    getIsFreePreviewLuxPlusMember(state) &&
    !subscriptionInCart &&
    !isLuxPlusPricingShownToEveryone

  if (isPreviewMemberBlocked) {
    return false
  }

  return getCanViewLuxPlusBenefits(state) ||
    (getIsFreePreviewLuxPlusMember(state) && getIsEnabledFlightsLuxPlusPreview(state)) ||
    subscriptionInCart ||
    getIsFlightsLuxPlusPricingEligibleSpoofedNonMember(state) ||
    isLuxPlusPricingShownToEveryone
}

export function getFlightSearchIsLuxPlusParam(
  requestLuxPlusPricing: boolean,
  applyDeclinedLuxPlusUpsell: boolean,
): boolean | undefined {
  if (requestLuxPlusPricing) {
    return true
  }

  if (applyDeclinedLuxPlusUpsell) {
    return false
  }

  return undefined
}
